import React , {Component} from "react";
import { Collapse } from 'antd'
import styled from 'styled-components'
const Panel = Collapse.Panel


const text1 = `Il vous suffit de cliquer sur le bouton "Se Connecter" et créer un compte `
const text2 = `Il faut envoyer un mail à l’adresse help@urbanfitnessfrance.com`
const text3 = `Vous pouvez réinitialiser votre mot de passe en cliquant sur "Mot de passe	oublié" en dessous de la page de connexion `
const text4 = `Malheureusement nous ne pouvons savoir d’où il venait, nous vous conseillons tout de même d’envoyer un mail à help@urbanfitnessfrance.com`
const text5 = `Créez votre profil, puis cliquez sur « vous êtes un professionnel ?» directement dans le formulaire d'inscription`
const text6 = `Aucun abonnement ne peut être résilié sauf sous conditions spécifiées dans votre contrat`
const text7 = `Envoyez un mail à help@urbanfitnessfrance.com`
const text8 = `Deux possibilités s’offrent à vous : en nous contactant via help@urbanfitnessfrance.com, ou nous vous le proposerons au bout de 3 mois de coaching`


const customPanelStyle = {
  border: 0,
  overflow: 'hidden',
  fontSize: '14px',
  width: '60%',
  fontWeight: "bold",
};

const dadam = {
  margin: 'auto',
  //paddingLeft: '25%',
}

const Center = styled.div `
margin-top: 20px;
padding-bottom: 50px;
margin-left: 100px;
`


export default class Questions extends Component {
  render () {
    return (
      <Center>
        <h1 style={{textAlign: 'left'}}>Questions récurrentes</h1>
          <Collapse bordered={false} accordion style={dadam}>
            <Panel  header="Comment s'inscrire ?" key="1" style={customPanelStyle}>
              <p>{text1}</p>
            </Panel>
            <Panel  header="J'ai perdu mon identifiant, que faire ?" key="2" style={customPanelStyle}>
              <p>{text2}</p>
            </Panel>
            <Panel  header="J'ai perdu mon mot de passe ?" key="3" style={customPanelStyle}>
              <p>{text3}</p>
            </Panel>
            <Panel  header="J'ai perdu mon code promo !" key="4" style={customPanelStyle}>
              <p>{text4}</p>
            </Panel>
            <Panel  header="Comment devenir un professionnel URBAN FITNESS ?" key="5" style={customPanelStyle}>
              <p>{text5}</p>
            </Panel>
            <Panel  header="Comment résilier mon abonnement ?" key="6" style={customPanelStyle}>
              <p>{text6}</p>
            </Panel>
            <Panel  header="Comment changer de formule (abonnement) ?" key="7" style={customPanelStyle}>
              <p>{text7}</p>
            </Panel>
            <Panel  header="Comment devenir ambassadeur ?" key="8" style={customPanelStyle}>
              <p>{text8}</p>
            </Panel>
          </Collapse>
      </Center>
    );
  }
}
